// src/OrderTrackingClassic.js
import React, { useState, useEffect, useRef } from "react";
import Table from 'components/Table/Table';
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import CloseIcon from '@material-ui/icons/Close';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
	DialogActions,
	DialogTitle,
	Box,
	withStyles,
	TextField,
	IconButton,
	Dialog,
	DialogContent,
	DialogContentText,
	InputAdornment,
	Button,
	Badge,
	Grid,
	MenuItem,
	Typography,
	InputLabel
} from "@material-ui/core";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { Styles } from "../styles";
import searchIcon from "assets/img/Search_Icon.png";
import {
	DatePicker,
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enUS, fr } from "date-fns/locale";
import { useTranslation } from 'react-i18next';
import ThriveStartUpEnrollment from 'apis/ThriveStartUpEnrollments/ThriveStartUpEnrollments';
import { toast } from 'react-toastify';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { format } from "date-fns";

const STEP_META = {
	request:      { name: 'Request Received' },
	verification: { name: 'Account Verification' },
	assignment:   { name: 'User Assignment' },
	welcome:      { name: 'Welcome Notification' },
	addon:        { name: 'Add-on Plans' },
	billingNotif: { name: 'Billing Notification' },
	billing:      { name: 'Billing Verification' },
};

// If historical records stored a slightly different step_name, add it here.
const ALIASES = {
	request: [],
	verification: [],
	assignment: [],
	welcome: [],
	addon: [],
	billingNotif: [],
	billing: [],
};

const STARTUP_STEPS = ['request', 'verification', 'assignment', 'welcome', 'addon', 'billingNotif', 'billing'];

const STEP_PREREQS = {
	request:      [],
	verification: ['request'],
	assignment:   ['verification'],
	welcome:      ['assignment'],
	addon:        ['welcome'],
	billingNotif: ['addon'],
	billing:      ['billingNotif'],
};

// Completed by the system (code) only -> user has no action, so its panel stays collapsed while pending
const SYSTEM_ONLY_STEPS = ['billingNotif'];

const DATE_FORMAT = "ddd, Do MMM 'YY - h:mm A";

const norm = (s) => (s || '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
const matchesStep = (key, stepName) => {
	const n = norm(stepName);
	if (!n) return false;
	return [STEP_META[key].name, ...(ALIASES[key] || [])].some(a => norm(a) === n);
};

// custom TextField
const CssTextField = withStyles({
	root: {
		'& label.Mui-focused': {
			color: '##D3D3D3',
		},
		'& .MuiFormLabel-root': {
			color: '#707070',
		},
		'& .MuiInputBase-input': {
			color: '#707070',
		},
		'& .MuiInput-underline:before': {
			borderBottomColor: '#707070!important',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: '#707070!important',
		},
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: '#707070',
			},
			'&:hover fieldset': {
				borderColor: '#707070',
			},
			'&.Mui-focused fieldset': {
				borderColor: '#707070',
			},
			'&.MuiOutlinedInput-root': {
				marginTop: 0,
				borderRadius: 20,
			},
		},
	},
})(TextField);

const ButtonLoader = () => (
	<div className="snippet" style={{ marginLeft: 25 }}>
		<div className="stage"><div className="dot-typing-p"></div></div>
	</div>
);

export default function OrderTrackingClassic({ activeStep: activeStepProp, setDialogObj, requestId, shipto, handleGet = () => {}, email, setSearchValue = () => {} }) {
	const [expandedSteps, setExpandedSteps] = useState({});
	const { t, i18n } = useTranslation();
	const classes = Styles();
	const [formValues, setFormValues] = useState({
		salesRepIds: [''],
		billingDate: moment(new Date()).format("YYYY-MM-DD"),
		salesPlan: 'Skip',
		freeFreight: 'Apply',
		accountVerified: 'Yes',
		editedShipto: shipto,
		editedEmail: email,
		comments:''
	});
	const [error, setError] = useState('');
	const [states, setStates] = useState({
		date: new Date()
	});
	const [reason, setReason] = useState('');
	const [reactivateShipto, setReactivateShipto] = useState(false);
	const [openReasonDialog, setOpenReasonDialog] = useState(false);
	const [approveLoading, setApproveLoading] = useState(false);
	const [rejectLoading, setRejectLoading] = useState(false);
	const [reasonSubmitLoading, setReasonSubmitLoading] = useState(false);
	const [billingLoading, setBillingLoading] = useState(false);
	const [addonLoading, setAddonLoading] = useState(false);

	const [data, setData] = useState([]);
	const [logsLoaded, setLogsLoaded] = useState(false);
	const { getstartupLogs, salesRepMappingApi, billingConfirmationApi, addOnPlansMappingApi, salesRepRejectAPI } = ThriveStartUpEnrollment();
	const locale = i18n.language == 'fr' ? fr : enUS;
	const {
		salesRepIds,
		billingDate,
		salesPlan,
		freeFreight,
		accountVerified,
		editedShipto,
		editedEmail,
		comments
	} = formValues;
	const [dormantDialog, setDormantDialog] = useState({
		open: false
	});

	// ── Step state derived from logs (by step_name) ────────────────────────────
	const logsFor = (key) => (data || []).filter(i => matchesStep(key, i.step_name));
	const isDone = (key) => logsFor(key).length > 0;
	const lastDateFor = (key) => {
		const l = logsFor(key);
		return l.length ? l[l.length - 1]?.createdAt : undefined;
	};
const isActiveKey = (key, idx) => {
		if (!logsLoaded) return idx === activeStepProp;
		if (isDone(key)) return false;
		return (STEP_PREREQS[key] || []).every(isDone);
	};

	const dormantYesLoading = approveLoading;
	const approveSubmittingRef = useRef(false); // Approve + Dormant "Yes"
	const rejectSubmittingRef  = useRef(false); // Reason-dialog Submit
	const billingSubmittingRef = useRef(false); // Billing Verification Confirm
	const addonSubmittingRef   = useRef(false); // Add-on Plans Confirm
	const guardedSubmit = (ref, fn) => async (...args) => {
		if (ref.current) return;
		ref.current = true;
		try {
			await fn(...args);
		} finally {
			ref.current = false;
		}
	};


	useEffect(() => {
		handleGetLogs();
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;

		setFormValues(prev => ({
			...prev,
			[name]: value
		}));

		// Clear error for the field being edited
		setError(prev => ({
			...prev,
			[name]: ""
		}));
	};
	// ── Multiple Sales Rep Email handling ─────────────────────────────────────
	const handleSalesRepIdChange = (index, value) => {
		setFormValues(prev => {
			const updated = [...prev.salesRepIds];
			updated[index] = value;
			return { ...prev, salesRepIds: updated };
		});

		// live duplicate check (case-insensitive, ignores blanks)
		const normalized = value.trim().toLowerCase();
		if (normalized) {
			const duplicateExists = salesRepIds.some(
				(rep, i) => i !== index && rep.trim().toLowerCase() === normalized
			);
			if (duplicateExists) {
				setError(prev => ({ ...prev, salesRepId: "Duplicate Sales Rep Email is not allowed." }));
				return;
			}
		}
		setError(prev => ({ ...prev, salesRepId: '' }));
	};

	const addSalesRepId = () => {
		const trimmedReps = salesRepIds.map(r => r.trim()).filter(Boolean);
		const lastEntry = salesRepIds[salesRepIds.length - 1]?.trim();

		if (!lastEntry) {
			toast.error("Please fill the current Sales Rep Email before adding another.");
			return;
		}

		const hasDuplicates = new Set(trimmedReps.map(r => r.toLowerCase())).size !== trimmedReps.length;
		if (hasDuplicates) {
			toast.error("Duplicate Sales Rep Email is not allowed.");
			return;
		}

		setFormValues(prev => ({ ...prev, salesRepIds: [...prev.salesRepIds, ''] }));
	};

	const removeSalesRepId = (index) => {
		setFormValues(prev => {
			if (prev.salesRepIds.length === 1) return prev; // keep at least one field
			const updated = prev.salesRepIds.filter((_, i) => i !== index);
			return { ...prev, salesRepIds: updated };
		});
		setError(prev => ({ ...prev, salesRepId: '' }));
	};


	const handleGetLogs = async () => {
		try {
			let values = {
				requestId: requestId,
				type: "Enrollment",
				shipto: shipto
			};

			const res = await getstartupLogs(values);

			if (res) {
				setData(res.data || []);
				setLogsLoaded(true);

				const enrollmentDate = res.enrollmentDate;
				const dormantcheck = res?.dormantcheck

				setStates(prev => ({
					...prev,
					minEnrollmentDate: enrollmentDate,
					dormantcheck: dormantcheck
				}));
			}
		} catch (e) {
			console.error('Get error:', e);
		}
	};


	// Only completed steps can be expanded/collapsed manually (active steps open automatically)
	const toggleStep = (index) => {
		const key = STARTUP_STEPS[index];
		if (isDone(key)) {
			setExpandedSteps(prev => ({
				...prev,
				[index]: !prev[index],
			}));
		}
	};

	const handleSubmitSalesRepId = async (reactive) => {

		setError({});

		// Multiple Sales Rep Email validation
		const trimmedReps = salesRepIds.map(r => r.trim()).filter(Boolean);

		if (trimmedReps.length === 0) {
			setError({ ...error, salesRepId: "At least one Sales Rep Email is required." })
			return;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const invalidRep = trimmedReps.find(r => !emailRegex.test(r));
		if (invalidRep) {
			setError({ ...error, salesRepId: `"${invalidRep}" is not a valid email address.` })
			return;
		}

		const lowerCasedReps = trimmedReps.map(r => r.toLowerCase());
		if (new Set(lowerCasedReps).size !== lowerCasedReps.length) {
			setError({ ...error, salesRepId: "Duplicate Sales Rep Email is not allowed." })
			return;
		}

		if (!editedEmail || !editedEmail.trim()) {
			setError({ ...error, editedEmail: "Customer Email is required." })
			return;
		}
		if (!editedShipto || !editedShipto.trim()) {
			setError({ ...error, editedShipto: "Shipto is required." })
			return;
		}

		if (!emailRegex.test(editedEmail)) {
			setError({ ...error, editedEmail: "Please enter a valid email address." })
			return;
		}

		if (!shipto || !requestId) {
			toast.error("Missing required data (shipto or requestId).");
			return;
		}

		if (!states?.date || states?.date == 'Invalid date') {
			toast.error("Please select the start date");
			return;
		}

		try {
			setApproveLoading(true)
			const finalShipto = (shipto == editedShipto) ? shipto : editedShipto

			const values = {
				salesRepIds: trimmedReps,
				shipto: finalShipto,
				requestId,
				startDate: states.date ? format(states.date, "yyyy-MM-dd") : null,
				accountVerified,
				reactivate: reactivateShipto ? reactivateShipto : reactive,
				comments: comments,
				...(editedEmail != email && { editedEmail }),
			};

			const res = await salesRepMappingApi(values);
			setApproveLoading(false)
			if (res.result_status == 0) {
				toast.error(res.message)
			}
			if (res.result_status == 2) {
				setDormantDialog({ open: true })
			}

			if (res?.message == "Verification completed successfully") {
				setDialogObj({ open: false, obj: {}, index: null });
				if (res && res?.courtesyPoints > 0) {
					toast.success(`You have been given ${res?.courtesyPoints} points due to back date.`);
				}
				setSearchValue('')
			}

		} catch (e) {
			console.error('API Error:', e);
			setApproveLoading(false)
			toast.error("An error occurred while submitting.");
		}
	};

	const handleReject = async (reason) => {
		try {
			setRejectLoading(true);
			setReasonSubmitLoading(true);

			if (!shipto || !requestId) {
				toast.error("Missing required data (shipto or requestId).");
				return;
			}

			const values = {
				requestId,
				shipto,
				reason
			};

			const res = await salesRepRejectAPI(values);

			if (res) {
				setDialogObj({ open: false, obj: {}, index: null });
				setSearchValue('')
			}
		} catch (e) {
			console.error('API Error:', e);
			toast.error("An error occurred while submitting.");
		} finally {
			setDialogObj({ open: false, obj: {}, index: null });
			setSearchValue('')
			setRejectLoading(false);
			setReasonSubmitLoading(false);
		}
	};

	// Open the reason dialog
	const handleOpenReasonDialog = () => {
		setOpenReasonDialog(true);
	};

	// Close the reason dialog without submission
	const handleCloseReasonDialog = () => {
		setOpenReasonDialog(false);
		setReason('');
	};

	// Submit the reason and call handleReject
	const guardedHandleReject = guardedSubmit(rejectSubmittingRef, handleReject);
	const handleSubmitReasonDialog = () => {
		if (reason) {
			guardedHandleReject(reason);
			setOpenReasonDialog(false);
			setReason('');
		} else {
			toast.error("Please enter a reason.");
		}
	};


	const handleBillingVerification = async () => {
		try {
			if (!billingDate || billingDate == 'Invalid date') {
				toast.error("Please select a billing date.");
				return;
			}

			if (!shipto || !requestId) {
				toast.error("Missing required information (shipto or requestId).");
				return;
			}

			setBillingLoading(true);

			const values = {
				billingDate,
				shipto,
				requestId,
			};

			const res = await billingConfirmationApi(values);

			if (res) {
				setDialogObj({ open: false, obj: {}, index: null });
				setSearchValue('')
			}
		} catch (e) {
			console.error("API Error:", e);
			toast.error("An error occurred during billing verification.");
		} finally {
			setBillingLoading(false);
		}
	};


	const handleAddonPlans = async () => {
		try {
			if (!salesPlan) { toast.error("Please select a Sales Plan option."); return; }
			if (!freeFreight) { toast.error("Please select a Free Freight option."); return; }
			if (!shipto || !requestId) { toast.error("Missing required data."); return; }
			setAddonLoading(true);
			const res = await addOnPlansMappingApi({ salesPlan, freeFreight, shipto, requestId });
			if (res) { setDialogObj({ open: false, obj: {}, index: null }); handleGet(); }
		} catch (e) {
			console.error("API error:", e);
			toast.error("An error occurred while submitting Add-on Plans.");
		} finally {
			setAddonLoading(false);
			setDialogObj({ open: false, obj: {}, index: null });
			handleGet();
		}
	};

	// Default log list: note + timestamp
	const renderSimpleLogs = (key) => (
		<ul>
			{logsFor(key).map((d, i) => (
				<li key={d.id || i}>
					<div>
						<span style={{ color: 'black' }}>{d.notes}</span><br />
						<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format(DATE_FORMAT)}</span>
					</div>
				</li>
			))}
		</ul>
	);

	// Shared props for every Step
	const stepProps = (index) => {
		const key = STARTUP_STEPS[index];
		const active = isActiveKey(key, index);
		const done = isDone(key);
		return {
			index,
			isActive: active,
			// system-only steps have nothing to show/do while pending, so keep them collapsed
			autoOpen: active && !(SYSTEM_ONLY_STEPS.includes(key) && !done),
			toggleStep,
			expandedSteps,
			isCompleted: done,
			date: lastDateFor(key),
		};
	};

	const welcomeLogs = logsFor('welcome');
	const lastWelcome = welcomeLogs[welcomeLogs.length - 1];

	return (
		<div className="order-tracking">
			<style>{`
                .order-tracking {
                  max-width: 550px;
                  margin: auto;
                  font-family: "Arial", sans-serif;
                  color: #333;
                  background: #fff;
                  padding: 1.5rem;
                  border-radius: 8px;
                }
                .step {
                  display: flex;
                  position: relative;
                  margin-bottom: 2rem;
                }
                .circle-container {
                  position: relative;
                  width: 40px;
                  display: flex;
                  justify-content: center;
                }
                .circle {
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.75rem;
                  font-weight: bold;
                  transition: all 0.3s ease;
                  background: #f5f5f5;
                  border: 2px solid #ccc;
                  color: #777;
                  z-index: 1;
                }
                .timeline {
                  position: absolute;
                  top: 24px;
                  bottom: -24px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 2px;
                  background: #e0e0e0;
                }
                .step:last-child .timeline {
                  display: none;
                }
                .step.active .circle {
                  background: #1976d2;
                  color: #fff;
                  border: 2px solid #1976d2;
                }
                .step.completed .circle {
                  background: #4CAF50;
                  color: #fff;
                  border: 2px solid #4CAF50;
                }
                .step-body {
                  flex: 1;
                  padding-left: 0.75rem;
                  min-width: 0;
                }
                .step-header {
                  cursor: pointer;
                  margin-bottom: 0.3rem;
                }
                .step-title {
                  font-weight: 600;
                  font-size: 1rem;
                }
				.step-title-incomplete {
				  font-weight: 600;
                  font-size: 1rem;
				  opacity: 0.5;
				}
                .step-date {
                  font-size: 0.85rem;
                  color: #666;
                }
                .step-content {
                  max-height: 0;
                  overflow: hidden;
                  transition: max-height 0.3s ease;
                }
                .step-content.open {
                  max-height: 1000px;
                  margin-top: 0.5rem;
				  border: 1px solid #ddd;
				  padding: 15px;
				  border-radius: 5px;
				  box-sizing: border-box;
				  overflow-wrap: anywhere;
                }
                .step-content ul {
                  margin: 0.5rem 0;
                  padding-left: 1.2rem;
                }
                .step-content li {
                  margin-bottom: 0.3rem;
                  font-size: 0.9rem;
                  color: #444;
                  word-break: break-word;
                  overflow-wrap: anywhere;
                }
                .step-content li span {
                  word-break: break-word;
                  overflow-wrap: anywhere;
                }
                .actions {
                  margin-top: 0.6rem;
                  display: flex;
				  flex-direction: column;
                  gap: 10px;
                  float: none;
                }
                .actions button {
                  padding: 0.5rem 0.8rem;
                  border: 1px solid #1976d2;
                  border-radius: 4px;
                  background: #1976d2;
                  color: white;
                  font-size: 0.85rem;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .actions button:hover {
                  background: #1565c0;
                }
                .actions button:disabled {
                  background: #f0f0f0;
                  border: 1px solid #ccc;
                  color: #999;
                  cursor: not-allowed;
                }
                .finished {
                  margin-top: 1rem;
                  padding: 1rem;
                  background: #f9f9f9;
                  border: 1px solid #ddd;
                  text-align: center;
                  border-radius: 6px;
                }
                .finished p {
                  margin: 0;
                  font-size: 0.95rem;
                  font-weight: 500;
                  color: #2e7d32;
                }
                .finished button {
                  margin-top: 0.7rem;
                  padding: 0.5rem 1rem;
                  border-radius: 4px;
                  border: 1px solid #1976d2;
                  background: #1976d2;
                  color: white;
                  cursor: pointer;
                  font-size: 0.85rem;
                }
                .finished button:hover {
                  background: #1976d2;
                }
            `}</style>

			{/* Step 1 - Request Received */}
			<Step
				{...stepProps(0)}
				title="Request Received"
				content={renderSimpleLogs('request')}
			/>

			{/* Step 2 - Account Verification */}
			<Step
				{...stepProps(1)}
				title="Account Verification"
				content={isDone('verification') ? (
					renderSimpleLogs('verification')
				) : (
					<div>
						<div style={{ marginTop: 10 }}>
							<InputLabel htmlFor="editedShipto" className={classes.labelTxt}>Enter the Shipto <span style={{ color: 'red' }}>*</span> </InputLabel>
							<TextField
								id="editedShipto"
								type="number"
  onWheel={(e) => e.target.blur()}
								variant="outlined"
								autoComplete="off"
								className={classes.searchInput}
								style={{ width: '90%' }}
								value={editedShipto}
								name="editedShipto"
								onChange={handleChange}
								inputProps={{ maxLength: 100 }}
								error={!!error.editedShipto}
								helperText={error.editedShipto}
							/>
						</div>
						<div style={{ marginTop: 10 }}>
							<InputLabel htmlFor="editedEmail" className={classes.labelTxt}>
								Enter the Customers Email ID <span style={{ color: 'red' }}>*</span> </InputLabel >
							<TextField
								id="editedEmail"
								type="email"
								variant="outlined"
								autoComplete="off"
								className={classes.searchInput}
								style={{ width: '90%' }}
								value={editedEmail}
								name="editedEmail"
								onChange={handleChange}
								inputProps={{ maxLength: 100 }}
								error={!!error.editedEmail}
								helperText={error.editedEmail}
							/>
						</div>
						<div style={{ marginTop: 10 }}>
							<InputLabel htmlFor="salesRepId-0" className={classes.labelTxt}>
								Sales Rep Email ID(s) <span style={{ color: 'red' }}>*</span>
							</InputLabel>

							{salesRepIds.map((repEmail, index) => (
								<Box key={index} display="flex" alignItems="center" style={{ width: '90%', marginBottom: 8 }}>
									<TextField
										id={`salesRepId-${index}`}
										type="email"
										variant="outlined"
										autoComplete="off"
										className={classes.searchInput}
										fullWidth
										placeholder="Enter Sales Rep Email"
										value={repEmail}
										name="salesRepId"
										onChange={(e) => handleSalesRepIdChange(index, e.target.value)}
										inputProps={{ maxLength: 100 }}
									/>
									{salesRepIds.length > 1 && (
										<IconButton onClick={() => removeSalesRepId(index)} size="small" style={{ marginLeft: 4 }}>
											<CloseIcon fontSize="small" />
										</IconButton>
									)}
								</Box>
							))}

							{error.salesRepId && (
								<div style={{ color: '#f44336', fontSize: '0.75rem', marginBottom: 8 }}>
									{error.salesRepId}
								</div>
							)}

							<Button onClick={addSalesRepId} size="small" style={{ textTransform: 'none', padding: 0 }}>
								+ Add another Sales Rep
							</Button>
						</div>
						<div style={{ marginTop: 10 }}>
							<InputLabel htmlFor="startDate" className={classes.labelTxt}>
								Enrollment Start Date <span style={{ color: 'red' }}>*</span> </InputLabel >
							<MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
								<KeyboardDatePicker
									disableToolbar
									name="startDate"
									inputVariant="outlined"
									format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
									margin="normal"
									id="billing-date-picker"
									className={classes.dateInput1}
									value={states?.date || null}
									inputProps={{
										readOnly: states?.dormantcheck // blocks manual typing
									}}
									maxDate={new Date()}
									minDate={
										states?.dormantcheck
											? new Date()
											: new Date(states?.minEnrollmentDate)
									}
									onChange={(date) => setStates({ ...states, date })}
									KeyboardButtonProps={{
										"aria-label": "change date",
									}}
									autoOk
									fullWidth
								/>
							</MuiPickersUtilsProvider>
						</div>
						<div style={{ marginTop: 10 }}>
							<InputLabel htmlFor="comments" className={classes.labelTxt}>
								Comments </InputLabel>
							<TextField
								id="comments"
								type="text"
								variant="outlined"
								autoComplete="off"
								className={classes.searchInput}
								style={{ width: '90%' }}
								value={comments}
								name="comments"
								onChange={handleChange}
								inputProps={{ maxLength: 100 }}
							/>
						</div>
					</div>
				)}
				button={
					!isDone('verification') && <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: 10 }}>
						<div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
							<button onClick={handleOpenReasonDialog}
								disabled={approveLoading || rejectLoading}
								style={{
									color: "#305698",
									backgroundColor: "#fff",
									border: "1px solid #305698",
								}}>{rejectLoading ? <ButtonLoader /> : 'Reject'}</button>
							<button
								disabled={approveLoading || rejectLoading}
								style={{
									color: "white",
									backgroundColor: "#1976d2",
									border: "1px solid #1976d2",
								}}
								onClick={() => guardedSubmit(approveSubmittingRef, handleSubmitSalesRepId)(false)}> {approveLoading ?
									<ButtonLoader />
									:
									'Approve'}</button>
						</div>
					</div>
				}
			/>

			{/* Step 3 - User Assignment (Field Promotions Notification step removed) */}
			<Step
				{...stepProps(2)}
				title="User Assignment"
				content={
					<ul>
						{logsFor('assignment').map((d, i) => (
							<li key={d.id || i}>
								<div>
									<span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format(DATE_FORMAT)}</span>
								</div>
								{d.start_date && <div><span>Enrollment Start Date :{moment(d.start_date).format("MM/DD/YYYY")}</span></div>}
								{d.loyalty_id && <div><span>Member ID :{d.loyalty_id}</span></div>}
							</li>
						))}
					</ul>
				}
			/>

			{/* Step 4 - Welcome Notification */}
			<Step
				{...stepProps(3)}
				title="Welcome Notification"
				date={lastWelcome?.notes?.toLowerCase().includes('not sent') ? null : lastWelcome?.createdAt}
				content={
					<ul>
						{welcomeLogs.map((d, i) => (
							<li key={d.id || i}>
								<div>
									<span style={{ color: 'black' }}>{d.notes}</span>
									<br />
									{!d.notes?.toLowerCase().includes('not sent') && (
										<span style={{ fontStyle: 'italic' }}>
											{moment(d.createdAt).format(DATE_FORMAT)}
										</span>
									)}
								</div>
							</li>
						))}
					</ul>
				}
			/>

			{/* Step 5 - Add-on Plans (runs in parallel with Billing Notification) */}
			<Step
				{...stepProps(4)}
				title="Add-on Plans"
				content={isDone('addon') ?
					renderSimpleLogs('addon') :
					<ul>
						<li style={{ marginBottom: '12px' }}>
							<label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>Sales Plan:</label>
							<label>
								<input
									type="radio"
									name="salesPlan"
									value="Apply"
									style={{ marginRight: 6 }}
									checked={formValues.salesPlan === "Apply"}
									onChange={handleChange}
								/>
								Apply
							</label>
							<label style={{ marginLeft: 20 }}>
								<input
									type="radio"
									name="salesPlan"
									value="Skip"
									style={{ marginRight: 6 }}
									checked={formValues.salesPlan === "Skip"}
									onChange={handleChange}
								/>
								Skip
							</label>
						</li>

						<li style={{ marginBottom: '12px' }}>
							<label style={{ fontWeight: '600', display: 'block', marginBottom: '4px' }}>FF/Surcharge:</label>
							<label>
								<input
									type="radio"
									name="freeFreight"
									value="Apply"
									style={{ marginRight: 6 }}
									checked={formValues.freeFreight === "Apply"}
									onChange={handleChange}
								/>
								Apply
							</label>
							<label style={{ marginLeft: 20 }}>
								<input
									type="radio"
									name="freeFreight"
									value="Skip"
									style={{ marginRight: 6 }}
									checked={formValues.freeFreight === "Skip"}
									onChange={handleChange}
								/>
								Skip
							</label>
						</li>
					</ul>
				}
				button={!isDone('addon') && (
					<button onClick={() => guardedSubmit(addonSubmittingRef, handleAddonPlans)()} disabled={addonLoading}>
						{addonLoading ? <ButtonLoader /> : 'Confirm'}
					</button>
				)}
			/>

			{/* Step 6 - Billing Notification (system only, parallel with Add-on Plans) */}
			<Step
				{...stepProps(5)}
				title="Billing Notification"
				content={renderSimpleLogs('billingNotif')}
			/>

			{/* Step 7 - Billing Verification (needs Add-on Plans + Billing Notification done) */}
			<Step
				{...stepProps(6)}
				title="Billing Verification"
				content={isDone('billing') ?
					<ul>
						{logsFor('billing').map((d, i) => (
							<li key={d.id || i}>
								<div>
									<span style={{ color: 'black' }}>{d.notes}</span><br />
									<span style={{ fontStyle: 'italic' }}>{moment(d.createdAt).format(DATE_FORMAT)}</span>
								</div>
								<div><span>Billing Start Date :{d.value}</span></div>
							</li>
						))}
					</ul> :
					<div>
						<MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
							<KeyboardDatePicker
								disableToolbar
								name="billingDate"
								inputVariant="outlined"
								format={i18n.language === "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
								margin="normal"
								label="Billing Date"
								id="billing-date-picker"
								className={classes.dateInput}
								value={formValues.billingDate || null}
								minDate={new Date()}
								onChange={date => setFormValues({ ...formValues, billingDate: moment(date).format("YYYY-MM-DD") })}
								KeyboardButtonProps={{
									"aria-label": "change date",
								}}
								autoOk
								fullWidth
							/>
						</MuiPickersUtilsProvider>
					</div>
				}
				button={!isDone('billing') && (
					<button onClick={() => guardedSubmit(billingSubmittingRef, handleBillingVerification)()} disabled={billingLoading}>
						{billingLoading ? <ButtonLoader /> : 'Confirm'}
					</button>
				)}
			/>

			<Dialog open={openReasonDialog} onClose={handleCloseReasonDialog}>
				<DialogTitle>Reason for Rejection</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						label="Reason"
						type="text"
						fullWidth
						variant="outlined"
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						required
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseReasonDialog} color="secondary" disabled={reasonSubmitLoading}>
						Cancel
					</Button>
					<Button onClick={handleSubmitReasonDialog} color="primary" disabled={reasonSubmitLoading}>
						{reasonSubmitLoading ? <ButtonLoader /> : 'Submit'}
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={dormantDialog.open}
				onClose={() => {
					setDormantDialog({ open: false });
					setReactivateShipto(true)
				}}
				maxWidth="sm"
				style={{ fontFamily: "Segoe-ui" }}
			>
				<div style={{ padding: 20 }}>
					<h2 style={{ marginBottom: 10 }}> <span>
						{t(
							`Proceed with Reactivation and Startup Enrollment`
						)}
					</span></h2>
					<p>
						This Shipto is dormant. Do you want to change it to earning status and proceed with Startup enrollment? Click 'Yes' to proceed.
					</p>
					<div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
						<Button
							onClick={() => {
								setDormantDialog({ open: false });
								setReactivateShipto(false)
							}}
							variant="outlined"
							style={{ marginRight: 10 }}
							disabled={dormantYesLoading}
						>
							No
						</Button>
						<Button
							onClick={() => {
								setDormantDialog({ open: false });
								setReactivateShipto(true)
								guardedSubmit(approveSubmittingRef, handleSubmitSalesRepId)(true)
							}}
							variant="contained"
							color="primary"
							disabled={dormantYesLoading}
						>
							{dormantYesLoading ? <ButtonLoader /> : 'Yes'}
						</Button>
					</div>
				</div>
			</Dialog>
		</div>
	);
}


// Helper component
function Step({ index, isActive, autoOpen, expandedSteps, toggleStep, title, isCompleted, date, content, button }) {
	const isExpanded = autoOpen || expandedSteps[index];

	return (
		<div className={`step ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}>
			<div className="circle-container">
				<div className="circle">{isCompleted ? "✓" : index + 1}</div>
				<div className="timeline"></div>
			</div>
			<div className="step-body">
				<div className="step-header" onClick={() => toggleStep(index)}>
					<div className={(isCompleted || isActive) ? "step-title" : "step-title-incomplete"}>{title}</div>
					<div className="step-date">{date ? moment(date).format(DATE_FORMAT) : ""}</div>
				</div>
				<div className={`step-content ${isExpanded ? "open" : ""}`}>
					{content}
					<div className="actions">{button}</div>
				</div>
			</div>
		</div>
	);
}